import { Language } from "@/types/__generated__/union-types"

type DocumentLanguage = Exclude<Language, "ENGLISH">

const DOCUMENT_LANGUAGES: Array<{ value: DocumentLanguage; label: string }> = [
  { value: "GERMAN", label: "common.languageList.german" },
  { value: "FRENCH", label: "common.languageList.french" },
  { value: "ITALIAN", label: "common.languageList.italian" },
]

const getDefaultDocumentLanguageValue = (language?: Language): DocumentLanguage => {
  return language && language !== "ENGLISH" && DOCUMENT_LANGUAGES.find((option) => option.value === language)
    ? language
    : "GERMAN"
}

const getDocumentLanguageLabel = (value: Language) =>
  DOCUMENT_LANGUAGES.find((option) => option.value === value)?.label ?? ""

export { DOCUMENT_LANGUAGES, type DocumentLanguage, getDefaultDocumentLanguageValue, getDocumentLanguageLabel }
